import { render, staticRenderFns } from "./MynaPortalDescription.vue?vue&type=template&id=60c6509a&scoped=true&"
import script from "./MynaPortalDescription.vue?vue&type=script&lang=ts&"
export * from "./MynaPortalDescription.vue?vue&type=script&lang=ts&"
import style0 from "./MynaPortalDescription.vue?vue&type=style&index=0&id=60c6509a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6509a",
  null
  
)

export default component.exports